import { render, staticRenderFns } from "./proofbillbox.vue?vue&type=template&id=f6163a30&scoped=true&"
import script from "./proofbillbox.vue?vue&type=script&lang=js&"
export * from "./proofbillbox.vue?vue&type=script&lang=js&"
import style0 from "./proofbillbox.vue?vue&type=style&index=0&id=f6163a30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6163a30",
  null
  
)

export default component.exports